import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { CompanyList } from "./companyListView";
import { useGetCompaniesQuery } from "../../api/companyApi";
import { LoadingIndicator } from "../shared/alerts/loadingIndicator";
import { Add } from "@mui/icons-material";
import { Collection } from "../../enums/collections.enum";
import { Link } from "react-router-dom";

export const CompanyListContainer = () => {
  const { data: companies, isLoading, error } = useGetCompaniesQuery();

  if (isLoading) return <LoadingIndicator message="Loading companies..." />;
  if (error) return <Typography color="error">Error: {String(error)}</Typography>;
 

  return <>
    <Stack direction="row" justifyContent="space-between" alignItems="center" mr={2}>
      <Typography variant="h5" fontWeight={600}>

      </Typography>
      <Button
        variant="contained"
        startIcon={<Add />}
        component={Link}
        to={`/${Collection.Companies}/add`}
      >
        Add Company
      </Button>
    </Stack>
    <CompanyList companies={companies} />
  </>
};

